
// Import Rails UJS and ActiveStorage
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

var turboRailsContext = require.context("@hotwired/turbo", true);
turboRailsContext.keys().forEach(turboRailsContext);

import "flowbite/dist/flowbite.turbo.js";
import "trix";
import "@rails/actiontext"
import "../lib/youtube.js";
import { initFlowbite } from 'flowbite'
import { Turbo } from "@hotwired/turbo-rails";

// Import contents of the controller folder
var controllerContext = require.context("../controllers", true);
controllerContext.keys().forEach(controllerContext);

import * as ActionCable from '@rails/actioncable'

ActionCable.logger.enabled = false;


// on turbo load
document.addEventListener("turbo:load", function () {
    initFlowbite();
});

import LocalTime from "local-time"
LocalTime.start()

Trix.config.blockAttributes.heading1.tagName = "h2"

ReactRailsUJS.handleEvent('turbo:load', ReactRailsUJS.handleMount);
ReactRailsUJS.handleEvent('turbo:frame-load', ReactRailsUJS.handleMount, false);
ReactRailsUJS.handleEvent('turbo:before-render', ReactRailsUJS.handleUnmount);

Turbo.StreamActions.redirect = function () {
    Turbo.visit(this.target);
};

document.addEventListener("turbo:before-stream-render", (event) => {
    const fallbackToDefaultActions = event.detail.render;
    event.detail.render = function (streamElement) {
        if (streamElement.action == "redirect") {
            Turbo.visit(streamElement.target);
        } else {
            fallbackToDefaultActions(streamElement);
        }
    };
});




